import { GrooveTypeEnum, StandardCutoutAvailablePlates } from 'cloud-shared-lib';

export class CuttingStandardCutoutSlot {
  id: number;
  slotId: number;
  name: string;
  designation: string;
  h: number;
  g: number;
  dx: number;
  fi: number;
  b: number;
  r: number;
  type: GrooveTypeEnum;
  custom: boolean;
  availablePlates: StandardCutoutAvailablePlates;
  isSlotNameError: boolean;
}
